// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5058c68b","750":"4d932e24","849":"1deb2e73"}[chunkId] + ".chunk.js";
};